import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {PageTitle} from '../../../_ShakWala/layout/core'
import ExpAfterFiveDay from '../../pages/package-info/exp-in-five-day/ExpAfterFiveDay'

const ExpiredIn5PackageMasterPage: React.FC = () => {
  return (
    <Switch>
      <Route path='/package-info/expires-in5day/list'>
        <PageTitle>Package Expires In 5 Day List</PageTitle>
        <ExpAfterFiveDay />
      </Route>
      <Redirect
        from='/package-info/expires-in5day'
        exact={true}
        to='/package-info/expires-in5day/list'
      />
      <Redirect to='/package-info/expires-in5day/list' />
    </Switch>
  )
}

export default ExpiredIn5PackageMasterPage
